import styled from "styled-components";
import { palette } from "styled-theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 30px;

  .form-wrapper {
    width: 100%;
    display: ${props => props.checked ? "block" : "none"};
  }

  .consent-wrapper {
    display: flex;
    flex-direction: column;

    label {
      padding: 10px 0px;
    }
  }

  .refer-button {
    margin: 20px 0px;
    width: 200px;
  }

  .keep-in-touch {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px 0 10px;
    border-top: 1px solid ${palette("tracking", 0)};
  }

  .keep-in-touch-content {
    padding-bottom: 15px;
    text-align: center;
  }

  .keep-in-touch-thanks {
    text-align: center;
    padding-bottom: 5px;
  }

  .keep-in-touch-fgf {
    color: ${palette("color", 15)};
    text-align: center;
  }
`;
